<script>
export default {
  props: ["clr", "backClr", "borderClr"]
};
</script>
<template>
  <svg
    id="user-profile-circle"
    xmlns="http://www.w3.org/2000/svg"
    width="62"
    height="62"
    viewBox="0 0 62 62"
  >
    <path id="Path_8306" data-name="Path 8306" d="M0,0H62V62H0Z" fill="none" />
    <circle
      id="Ellipse_115"
      data-name="Ellipse 115"
      cx="23.25"
      cy="23.25"
      r="23.25"
      transform="translate(7.75 7.75)"
      :fill="backClr ? backClr : '#002'"
      :stroke="borderClr ? borderClr : '#002'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="4"
    />
    <path
      id="Path_8307"
      data-name="Path 8307"
      d="M28.667,18.111h0A5.438,5.438,0,0,0,27.3,16.124h0a5.446,5.446,0,0,0-3.7-1.457H13.071a5.453,5.453,0,0,0-3.707,1.457h0A5.492,5.492,0,0,0,8,18.111"
      transform="translate(12.667 23.223)"
      fill="none"
      :stroke="clr ? clr : '#002'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="4"
    />
    <circle
      id="Ellipse_116"
      data-name="Ellipse 116"
      cx="5.813"
      cy="5.813"
      r="5.813"
      transform="translate(25.188 20.667)"
      fill="none"
      :stroke="clr ? clr : '#002'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="4"
    />
  </svg>
</template>
